// Multi-language translations for 9Reason website
// Languages: English (en), Hindi (hi), Punjabi (pa), French (fr)

export const translations = {
  // ============================================
  // NAVIGATION
  // ============================================
  nav: {
    en: {
      services: "Services",
      process: "Process",
      industries: "Industries",
      about: "About",
      events: "Events",
      projects: "Projects",
      contact: "Let's Talk",
      selectLanguage: "Language"
    },
    hi: {
      services: "सेवाएं",
      process: "प्रक्रिया",
      industries: "उद्योग",
      about: "हमारे बारे में",
      events: "कार्यक्रम",
      projects: "प्रोजेक्ट्स",
      contact: "संपर्क करें",
      selectLanguage: "भाषा"
    },
    pa: {
      services: "ਸੇਵਾਵਾਂ",
      process: "ਪ੍ਰਕਿਰਿਆ",
      industries: "ਉਦਯੋਗ",
      about: "ਸਾਡੇ ਬਾਰੇ",
      events: "ਸਮਾਗਮ",
      projects: "ਪ੍ਰੋਜੈਕਟਸ",
      contact: "ਸੰਪਰਕ ਕਰੋ",
      selectLanguage: "ਭਾਸ਼ਾ"
    },
    fr: {
      services: "Services",
      process: "Processus",
      industries: "Industries",
      about: "À Propos",
      events: "Événements",
      projects: "Projets",
      contact: "Contactez-nous",
      selectLanguage: "Langue"
    }
  },

  // ============================================
  // HEADER / HERO
  // ============================================
  header: {
    en: {
      badge: "Custom Software Development Agency",
      title: "We Build Digital Products That",
      titleHighlight: "Drive Growth",
      description: "From concept to launch, we create custom software solutions that help businesses innovate, scale, and succeed in the digital age.",
      cta1: "Start Your Project",
      cta2: "View Our Work",
      stat1Label: "Projects Delivered",
      stat2Label: "Client Satisfaction",
      stat3Label: "Years Experience"
    },
    hi: {
      badge: "कस्टम सॉफ्टवेयर डेवलपमेंट एजेंसी",
      title: "हम डिजिटल प्रोडक्ट्स बनाते हैं जो",
      titleHighlight: "विकास को बढ़ावा दें",
      description: "कॉन्सेप्ट से लॉन्च तक, हम कस्टम सॉफ्टवेयर सॉल्यूशंस बनाते हैं जो व्यवसायों को डिजिटल युग में नवाचार, स्केल और सफल होने में मदद करते हैं।",
      cta1: "अपना प्रोजेक्ट शुरू करें",
      cta2: "हमारा काम देखें",
      stat1Label: "प्रोजेक्ट्स डिलीवर",
      stat2Label: "क्लाइंट संतुष्टि",
      stat3Label: "वर्षों का अनुभव"
    },
    pa: {
      badge: "ਕਸਟਮ ਸਾਫਟਵੇਅਰ ਡਿਵੈਲਪਮੈਂਟ ਏਜੰਸੀ",
      title: "ਅਸੀਂ ਡਿਜੀਟਲ ਪ੍ਰੋਡਕਟਸ ਬਣਾਉਂਦੇ ਹਾਂ ਜੋ",
      titleHighlight: "ਵਿਕਾਸ ਨੂੰ ਅੱਗੇ ਵਧਾਉਂਦੇ ਹਨ",
      description: "ਕੌਂਸੈਪਟ ਤੋਂ ਲੌਂਚ ਤੱਕ, ਅਸੀਂ ਕਸਟਮ ਸਾਫਟਵੇਅਰ ਹੱਲ ਬਣਾਉਂਦੇ ਹਾਂ ਜੋ ਕਾਰੋਬਾਰਾਂ ਨੂੰ ਡਿਜੀਟਲ ਯੁੱਗ ਵਿੱਚ ਨਵੀਨਤਾ, ਸਕੇਲ ਅਤੇ ਸਫਲ ਹੋਣ ਵਿੱਚ ਮਦਦ ਕਰਦੇ ਹਨ।",
      cta1: "ਆਪਣਾ ਪ੍ਰੋਜੈਕਟ ਸ਼ੁਰੂ ਕਰੋ",
      cta2: "ਸਾਡਾ ਕੰਮ ਦੇਖੋ",
      stat1Label: "ਪ੍ਰੋਜੈਕਟਸ ਡਿਲੀਵਰ",
      stat2Label: "ਕਲਾਇੰਟ ਸੰਤੁਸ਼ਟੀ",
      stat3Label: "ਸਾਲਾਂ ਦਾ ਤਜਰਬਾ"
    },
    fr: {
      badge: "Agence de Développement Logiciel",
      title: "Nous Créons des Produits Numériques qui",
      titleHighlight: "Stimulent la Croissance",
      description: "Du concept au lancement, nous créons des solutions logicielles sur mesure qui aident les entreprises à innover, à évoluer et à réussir à l'ère numérique.",
      cta1: "Démarrer Votre Projet",
      cta2: "Voir Nos Réalisations",
      stat1Label: "Projets Livrés",
      stat2Label: "Satisfaction Client",
      stat3Label: "Années d'Expérience"
    }
  },

  // ============================================
  // SERVICES
  // ============================================
  services: {
    en: {
      title: "Our Services",
      subtitle: "End-to-end software development solutions tailored to your business needs",
      service1: { title: "Mobile App Development", desc: "Native and cross-platform mobile applications for iOS and Android" },
      service2: { title: "Web Development", desc: "Responsive websites and web applications built with modern technologies" },
      service3: { title: "Custom Software", desc: "Tailored software solutions designed for your unique business processes" },
      service4: { title: "Cloud Solutions", desc: "Scalable cloud infrastructure and migration services" },
      service5: { title: "UI/UX Design", desc: "User-centered design that creates engaging digital experiences" },
      service6: { title: "Maintenance & Support", desc: "Ongoing support and maintenance to keep your software running smoothly" }
    },
    hi: {
      title: "हमारी सेवाएं",
      subtitle: "आपकी व्यावसायिक आवश्यकताओं के अनुरूप एंड-टू-एंड सॉफ्टवेयर डेवलपमेंट सॉल्यूशंस",
      service1: { title: "मोबाइल ऐप डेवलपमेंट", desc: "iOS और Android के लिए नेटिव और क्रॉस-प्लेटफॉर्म मोबाइल एप्लिकेशन" },
      service2: { title: "वेब डेवलपमेंट", desc: "आधुनिक तकनीकों के साथ बनी रिस्पॉन्सिव वेबसाइट्स और वेब एप्लिकेशन" },
      service3: { title: "कस्टम सॉफ्टवेयर", desc: "आपकी अनूठी व्यावसायिक प्रक्रियाओं के लिए डिज़ाइन किए गए टेलर्ड सॉफ्टवेयर सॉल्यूशंस" },
      service4: { title: "क्लाउड सॉल्यूशंस", desc: "स्केलेबल क्लाउड इंफ्रास्ट्रक्चर और माइग्रेशन सेवाएं" },
      service5: { title: "UI/UX डिज़ाइन", desc: "यूजर-केंद्रित डिज़ाइन जो आकर्षक डिजिटल अनुभव बनाता है" },
      service6: { title: "रखरखाव और सहायता", desc: "आपके सॉफ्टवेयर को सुचारू रूप से चलाने के लिए निरंतर सहायता और रखरखाव" }
    },
    pa: {
      title: "ਸਾਡੀਆਂ ਸੇਵਾਵਾਂ",
      subtitle: "ਤੁਹਾਡੀਆਂ ਕਾਰੋਬਾਰੀ ਲੋੜਾਂ ਅਨੁਸਾਰ ਐਂਡ-ਟੂ-ਐਂਡ ਸਾਫਟਵੇਅਰ ਡਿਵੈਲਪਮੈਂਟ ਹੱਲ",
      service1: { title: "ਮੋਬਾਈਲ ਐਪ ਡਿਵੈਲਪਮੈਂਟ", desc: "iOS ਅਤੇ Android ਲਈ ਨੇਟਿਵ ਅਤੇ ਕਰਾਸ-ਪਲੇਟਫਾਰਮ ਮੋਬਾਈਲ ਐਪਲੀਕੇਸ਼ਨਾਂ" },
      service2: { title: "ਵੈੱਬ ਡਿਵੈਲਪਮੈਂਟ", desc: "ਆਧੁਨਿਕ ਤਕਨਾਲੋਜੀਆਂ ਨਾਲ ਬਣੀਆਂ ਰਿਸਪੌਂਸਿਵ ਵੈੱਬਸਾਈਟਾਂ ਅਤੇ ਵੈੱਬ ਐਪਲੀਕੇਸ਼ਨਾਂ" },
      service3: { title: "ਕਸਟਮ ਸਾਫਟਵੇਅਰ", desc: "ਤੁਹਾਡੀਆਂ ਵਿਲੱਖਣ ਕਾਰੋਬਾਰੀ ਪ੍ਰਕਿਰਿਆਵਾਂ ਲਈ ਡਿਜ਼ਾਈਨ ਕੀਤੇ ਟੇਲਰਡ ਸਾਫਟਵੇਅਰ ਹੱਲ" },
      service4: { title: "ਕਲਾਉਡ ਹੱਲ", desc: "ਸਕੇਲੇਬਲ ਕਲਾਉਡ ਇਨਫ੍ਰਾਸਟ੍ਰਕਚਰ ਅਤੇ ਮਾਈਗ੍ਰੇਸ਼ਨ ਸੇਵਾਵਾਂ" },
      service5: { title: "UI/UX ਡਿਜ਼ਾਈਨ", desc: "ਯੂਜ਼ਰ-ਕੇਂਦ੍ਰਿਤ ਡਿਜ਼ਾਈਨ ਜੋ ਆਕਰਸ਼ਕ ਡਿਜੀਟਲ ਅਨੁਭਵ ਬਣਾਉਂਦਾ ਹੈ" },
      service6: { title: "ਰੱਖ-ਰਖਾਅ ਅਤੇ ਸਹਾਇਤਾ", desc: "ਤੁਹਾਡੇ ਸਾਫਟਵੇਅਰ ਨੂੰ ਸੁਚਾਰੂ ਢੰਗ ਨਾਲ ਚਲਾਉਣ ਲਈ ਨਿਰੰਤਰ ਸਹਾਇਤਾ ਅਤੇ ਰੱਖ-ਰਖਾਅ" }
    },
    fr: {
      title: "Nos Services",
      subtitle: "Solutions de développement logiciel de bout en bout adaptées à vos besoins",
      service1: { title: "Développement Mobile", desc: "Applications mobiles natives et multiplateformes pour iOS et Android" },
      service2: { title: "Développement Web", desc: "Sites web responsifs et applications web construits avec des technologies modernes" },
      service3: { title: "Logiciel Sur Mesure", desc: "Solutions logicielles personnalisées conçues pour vos processus métier uniques" },
      service4: { title: "Solutions Cloud", desc: "Infrastructure cloud évolutive et services de migration" },
      service5: { title: "Design UI/UX", desc: "Design centré sur l'utilisateur créant des expériences numériques engageantes" },
      service6: { title: "Maintenance & Support", desc: "Support et maintenance continus pour garder votre logiciel fonctionnel" }
    }
  },

  // ============================================
  // PROCESS
  // ============================================
  process: {
    en: {
      title: "Our Process",
      subtitle: "A proven methodology that delivers results",
      step1: { title: "Discovery", desc: "We dive deep into understanding your business, goals, and challenges to create a comprehensive project roadmap." },
      step2: { title: "Design", desc: "Our designers create intuitive interfaces and seamless user experiences that align with your brand." },
      step3: { title: "Development", desc: "Our expert developers bring designs to life using cutting-edge technologies and best practices." },
      step4: { title: "Launch", desc: "We ensure a smooth deployment and provide ongoing support to guarantee your success." }
    },
    hi: {
      title: "हमारी प्रक्रिया",
      subtitle: "एक सिद्ध पद्धति जो परिणाम देती है",
      step1: { title: "खोज", desc: "हम एक व्यापक प्रोजेक्ट रोडमैप बनाने के लिए आपके व्यवसाय, लक्ष्यों और चुनौतियों को गहराई से समझते हैं।" },
      step2: { title: "डिज़ाइन", desc: "हमारे डिज़ाइनर आपके ब्रांड के अनुरूप सहज इंटरफेस और निर्बाध उपयोगकर्ता अनुभव बनाते हैं।" },
      step3: { title: "डेवलपमेंट", desc: "हमारे विशेषज्ञ डेवलपर्स अत्याधुनिक तकनीकों और सर्वोत्तम प्रथाओं का उपयोग करके डिज़ाइन को जीवंत करते हैं।" },
      step4: { title: "लॉन्च", desc: "हम एक सुचारू तैनाती सुनिश्चित करते हैं और आपकी सफलता की गारंटी के लिए निरंतर सहायता प्रदान करते हैं।" }
    },
    pa: {
      title: "ਸਾਡੀ ਪ੍ਰਕਿਰਿਆ",
      subtitle: "ਇੱਕ ਸਾਬਤ ਵਿਧੀ ਜੋ ਨਤੀਜੇ ਦਿੰਦੀ ਹੈ",
      step1: { title: "ਖੋਜ", desc: "ਅਸੀਂ ਇੱਕ ਵਿਆਪਕ ਪ੍ਰੋਜੈਕਟ ਰੋਡਮੈਪ ਬਣਾਉਣ ਲਈ ਤੁਹਾਡੇ ਕਾਰੋਬਾਰ, ਟੀਚਿਆਂ ਅਤੇ ਚੁਣੌਤੀਆਂ ਨੂੰ ਡੂੰਘਾਈ ਨਾਲ ਸਮਝਦੇ ਹਾਂ।" },
      step2: { title: "ਡਿਜ਼ਾਈਨ", desc: "ਸਾਡੇ ਡਿਜ਼ਾਈਨਰ ਤੁਹਾਡੇ ਬ੍ਰਾਂਡ ਦੇ ਅਨੁਸਾਰ ਅਨੁਭਵੀ ਇੰਟਰਫੇਸ ਅਤੇ ਸਹਿਜ ਉਪਭੋਗਤਾ ਅਨੁਭਵ ਬਣਾਉਂਦੇ ਹਨ।" },
      step3: { title: "ਡਿਵੈਲਪਮੈਂਟ", desc: "ਸਾਡੇ ਮਾਹਰ ਡਿਵੈਲਪਰ ਅਤਿ-ਆਧੁਨਿਕ ਤਕਨਾਲੋਜੀਆਂ ਅਤੇ ਸਭ ਤੋਂ ਵਧੀਆ ਅਭਿਆਸਾਂ ਦੀ ਵਰਤੋਂ ਕਰਕੇ ਡਿਜ਼ਾਈਨ ਨੂੰ ਜੀਵਨ ਵਿੱਚ ਲਿਆਉਂਦੇ ਹਨ।" },
      step4: { title: "ਲੌਂਚ", desc: "ਅਸੀਂ ਇੱਕ ਸੁਚਾਰੂ ਤੈਨਾਤੀ ਯਕੀਨੀ ਬਣਾਉਂਦੇ ਹਾਂ ਅਤੇ ਤੁਹਾਡੀ ਸਫਲਤਾ ਦੀ ਗਰੰਟੀ ਲਈ ਨਿਰੰਤਰ ਸਹਾਇਤਾ ਪ੍ਰਦਾਨ ਕਰਦੇ ਹਾਂ।" }
    },
    fr: {
      title: "Notre Processus",
      subtitle: "Une méthodologie éprouvée qui donne des résultats",
      step1: { title: "Découverte", desc: "Nous approfondissons la compréhension de votre entreprise, vos objectifs et vos défis pour créer une feuille de route complète." },
      step2: { title: "Design", desc: "Nos designers créent des interfaces intuitives et des expériences utilisateur fluides alignées sur votre marque." },
      step3: { title: "Développement", desc: "Nos développeurs experts donnent vie aux designs en utilisant des technologies de pointe et les meilleures pratiques." },
      step4: { title: "Lancement", desc: "Nous assurons un déploiement fluide et fournissons un support continu pour garantir votre succès." }
    }
  },

  // ============================================
  // ABOUT
  // ============================================
  about: {
    en: {
      title: "About Us",
      subtitle: "Your Trusted Technology Partner",
      description: "9Reason is a custom software development agency based in Winnipeg, Canada. We specialize in building innovative digital solutions that help businesses transform and grow.",
      mission: "Our mission is to deliver exceptional software products that solve real business problems and create lasting value for our clients.",
      founded: "Founded",
      location: "Location",
      locationValue: "Winnipeg, Canada",
      team: "Our Team",
      teamDesc: "A dedicated team of developers, designers, and strategists passionate about creating impactful digital solutions."
    },
    hi: {
      title: "हमारे बारे में",
      subtitle: "आपका विश्वसनीय तकनीकी साझेदार",
      description: "9Reason विनिपेग, कनाडा में स्थित एक कस्टम सॉफ्टवेयर डेवलपमेंट एजेंसी है। हम नवीन डिजिटल सॉल्यूशंस बनाने में विशेषज्ञ हैं जो व्यवसायों को बदलने और बढ़ने में मदद करते हैं।",
      mission: "हमारा मिशन असाधारण सॉफ्टवेयर उत्पाद देना है जो वास्तविक व्यावसायिक समस्याओं को हल करते हैं और हमारे ग्राहकों के लिए स्थायी मूल्य बनाते हैं।",
      founded: "स्थापित",
      location: "स्थान",
      locationValue: "विनिपेग, कनाडा",
      team: "हमारी टीम",
      teamDesc: "प्रभावशाली डिजिटल सॉल्यूशंस बनाने के बारे में भावुक डेवलपर्स, डिज़ाइनरों और रणनीतिकारों की एक समर्पित टीम।"
    },
    pa: {
      title: "ਸਾਡੇ ਬਾਰੇ",
      subtitle: "ਤੁਹਾਡਾ ਭਰੋਸੇਮੰਦ ਤਕਨਾਲੋਜੀ ਸਾਥੀ",
      description: "9Reason ਵਿਨੀਪੈਗ, ਕੈਨੇਡਾ ਵਿੱਚ ਸਥਿਤ ਇੱਕ ਕਸਟਮ ਸਾਫਟਵੇਅਰ ਡਿਵੈਲਪਮੈਂਟ ਏਜੰਸੀ ਹੈ। ਅਸੀਂ ਨਵੀਨਤਾਕਾਰੀ ਡਿਜੀਟਲ ਹੱਲ ਬਣਾਉਣ ਵਿੱਚ ਮਾਹਰ ਹਾਂ ਜੋ ਕਾਰੋਬਾਰਾਂ ਨੂੰ ਬਦਲਣ ਅਤੇ ਵਧਣ ਵਿੱਚ ਮਦਦ ਕਰਦੇ ਹਨ।",
      mission: "ਸਾਡਾ ਮਿਸ਼ਨ ਅਸਾਧਾਰਨ ਸਾਫਟਵੇਅਰ ਉਤਪਾਦ ਪ੍ਰਦਾਨ ਕਰਨਾ ਹੈ ਜੋ ਅਸਲ ਕਾਰੋਬਾਰੀ ਸਮੱਸਿਆਵਾਂ ਨੂੰ ਹੱਲ ਕਰਦੇ ਹਨ ਅਤੇ ਸਾਡੇ ਗਾਹਕਾਂ ਲਈ ਸਥਾਈ ਮੁੱਲ ਬਣਾਉਂਦੇ ਹਨ।",
      founded: "ਸਥਾਪਿਤ",
      location: "ਟਿਕਾਣਾ",
      locationValue: "ਵਿਨੀਪੈਗ, ਕੈਨੇਡਾ",
      team: "ਸਾਡੀ ਟੀਮ",
      teamDesc: "ਪ੍ਰਭਾਵਸ਼ਾਲੀ ਡਿਜੀਟਲ ਹੱਲ ਬਣਾਉਣ ਬਾਰੇ ਜੋਸ਼ੀਲੇ ਡਿਵੈਲਪਰਾਂ, ਡਿਜ਼ਾਈਨਰਾਂ ਅਤੇ ਰਣਨੀਤੀਕਾਰਾਂ ਦੀ ਇੱਕ ਸਮਰਪਿਤ ਟੀਮ।"
    },
    fr: {
      title: "À Propos",
      subtitle: "Votre Partenaire Technologique de Confiance",
      description: "9Reason est une agence de développement logiciel personnalisé basée à Winnipeg, Canada. Nous sommes spécialisés dans la création de solutions numériques innovantes qui aident les entreprises à se transformer et à croître.",
      mission: "Notre mission est de fournir des produits logiciels exceptionnels qui résolvent de vrais problèmes commerciaux et créent une valeur durable pour nos clients.",
      founded: "Fondée",
      location: "Emplacement",
      locationValue: "Winnipeg, Canada",
      team: "Notre Équipe",
      teamDesc: "Une équipe dédiée de développeurs, designers et stratèges passionnés par la création de solutions numériques impactantes."
    }
  },

  // ============================================
  // INDUSTRIES
  // ============================================
  industries: {
    en: {
      title: "Industries We Serve",
      subtitle: "Delivering tailored solutions across diverse sectors",
      industry1: "Healthcare",
      industry2: "Finance",
      industry3: "E-Commerce",
      industry4: "Education",
      industry5: "Real Estate",
      industry6: "Logistics",
      industry7: "Manufacturing",
      industry8: "Entertainment"
    },
    hi: {
      title: "हम किन उद्योगों की सेवा करते हैं",
      subtitle: "विविध क्षेत्रों में अनुकूलित समाधान प्रदान करना",
      industry1: "स्वास्थ्य सेवा",
      industry2: "वित्त",
      industry3: "ई-कॉमर्स",
      industry4: "शिक्षा",
      industry5: "रियल एस्टेट",
      industry6: "लॉजिस्टिक्स",
      industry7: "मैन्युफैक्चरिंग",
      industry8: "मनोरंजन"
    },
    pa: {
      title: "ਅਸੀਂ ਕਿਹੜੇ ਉਦਯੋਗਾਂ ਦੀ ਸੇਵਾ ਕਰਦੇ ਹਾਂ",
      subtitle: "ਵੱਖ-ਵੱਖ ਖੇਤਰਾਂ ਵਿੱਚ ਅਨੁਕੂਲਿਤ ਹੱਲ ਪ੍ਰਦਾਨ ਕਰਨਾ",
      industry1: "ਸਿਹਤ ਸੰਭਾਲ",
      industry2: "ਵਿੱਤ",
      industry3: "ਈ-ਕਾਮਰਸ",
      industry4: "ਸਿੱਖਿਆ",
      industry5: "ਰੀਅਲ ਅਸਟੇਟ",
      industry6: "ਲੌਜਿਸਟਿਕਸ",
      industry7: "ਮੈਨੂਫੈਕਚਰਿੰਗ",
      industry8: "ਮਨੋਰੰਜਨ"
    },
    fr: {
      title: "Industries que Nous Servons",
      subtitle: "Fournir des solutions sur mesure dans divers secteurs",
      industry1: "Santé",
      industry2: "Finance",
      industry3: "E-Commerce",
      industry4: "Éducation",
      industry5: "Immobilier",
      industry6: "Logistique",
      industry7: "Fabrication",
      industry8: "Divertissement"
    }
  },

  // ============================================
  // CONTACT
  // ============================================
  contact: {
    en: {
      title: "Let's Build Something Great",
      subtitle: "Ready to start your project? Get in touch with us today.",
      namePlaceholder: "Your Name",
      emailPlaceholder: "Your Email",
      messagePlaceholder: "Tell us about your project...",
      sendButton: "Send Message",
      sending: "Sending...",
      successMessage: "Thank you! We'll get back to you soon.",
      errorMessage: "Something went wrong. Please try again.",
      phone: "Phone",
      email: "Email",
      address: "Address"
    },
    hi: {
      title: "आइए कुछ महान बनाएं",
      subtitle: "अपना प्रोजेक्ट शुरू करने के लिए तैयार हैं? आज ही हमसे संपर्क करें।",
      namePlaceholder: "आपका नाम",
      emailPlaceholder: "आपका ईमेल",
      messagePlaceholder: "अपने प्रोजेक्ट के बारे में बताएं...",
      sendButton: "संदेश भेजें",
      sending: "भेज रहा है...",
      successMessage: "धन्यवाद! हम जल्द ही आपसे संपर्क करेंगे।",
      errorMessage: "कुछ गलत हो गया। कृपया पुनः प्रयास करें।",
      phone: "फ़ोन",
      email: "ईमेल",
      address: "पता"
    },
    pa: {
      title: "ਆਓ ਕੁਝ ਮਹਾਨ ਬਣਾਈਏ",
      subtitle: "ਆਪਣਾ ਪ੍ਰੋਜੈਕਟ ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਤਿਆਰ ਹੋ? ਅੱਜ ਹੀ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
      namePlaceholder: "ਤੁਹਾਡਾ ਨਾਮ",
      emailPlaceholder: "ਤੁਹਾਡਾ ਈਮੇਲ",
      messagePlaceholder: "ਆਪਣੇ ਪ੍ਰੋਜੈਕਟ ਬਾਰੇ ਦੱਸੋ...",
      sendButton: "ਸੁਨੇਹਾ ਭੇਜੋ",
      sending: "ਭੇਜ ਰਿਹਾ ਹੈ...",
      successMessage: "ਧੰਨਵਾਦ! ਅਸੀਂ ਜਲਦੀ ਹੀ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰਾਂਗੇ।",
      errorMessage: "ਕੁਝ ਗਲਤ ਹੋ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
      phone: "ਫ਼ੋਨ",
      email: "ਈਮੇਲ",
      address: "ਪਤਾ"
    },
    fr: {
      title: "Construisons Quelque Chose de Grand",
      subtitle: "Prêt à démarrer votre projet? Contactez-nous aujourd'hui.",
      namePlaceholder: "Votre Nom",
      emailPlaceholder: "Votre Email",
      messagePlaceholder: "Parlez-nous de votre projet...",
      sendButton: "Envoyer le Message",
      sending: "Envoi en cours...",
      successMessage: "Merci! Nous vous répondrons bientôt.",
      errorMessage: "Une erreur s'est produite. Veuillez réessayer.",
      phone: "Téléphone",
      email: "Email",
      address: "Adresse"
    }
  },

  // ============================================
  // CTA BANNER
  // ============================================
  cta: {
    en: {
      title: "Ready to Transform Your Business?",
      subtitle: "Let's discuss how we can help you achieve your goals.",
      button: "Get Started"
    },
    hi: {
      title: "अपने व्यवसाय को बदलने के लिए तैयार हैं?",
      subtitle: "आइए चर्चा करें कि हम आपके लक्ष्यों को प्राप्त करने में कैसे मदद कर सकते हैं।",
      button: "शुरू करें"
    },
    pa: {
      title: "ਆਪਣੇ ਕਾਰੋਬਾਰ ਨੂੰ ਬਦਲਣ ਲਈ ਤਿਆਰ ਹੋ?",
      subtitle: "ਆਓ ਚਰਚਾ ਕਰੀਏ ਕਿ ਅਸੀਂ ਤੁਹਾਡੇ ਟੀਚਿਆਂ ਨੂੰ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਕਿਵੇਂ ਮਦਦ ਕਰ ਸਕਦੇ ਹਾਂ।",
      button: "ਸ਼ੁਰੂ ਕਰੋ"
    },
    fr: {
      title: "Prêt à Transformer Votre Entreprise?",
      subtitle: "Discutons de la façon dont nous pouvons vous aider à atteindre vos objectifs.",
      button: "Commencer"
    }
  },

  // ============================================
  // EVENTS PAGE
  // ============================================
  events: {
    en: {
      title: "Community Events",
      subtitle: "Supporting and celebrating our local community",
      missionTitle: "Our Community Mission",
      missionText: "At 9Reason, we believe in giving back. We actively support and organize events that bring our community together, celebrate our heritage, and create meaningful connections.",
      featuredTitle: "Featured Events",
      upcomingTitle: "Upcoming Events",
      pastTitle: "Past Events",
      viewDetails: "View Details",
      noEvents: "No events scheduled at this time.",
      supportedBy: "Proudly Supported By",
      organizeTitle: "Want to Organize an Event?",
      organizeText: "We're always looking to support community initiatives. If you have an event idea or need sponsorship, get in touch!",
      contactUs: "Contact Us"
    },
    hi: {
      title: "सामुदायिक कार्यक्रम",
      subtitle: "हमारे स्थानीय समुदाय का समर्थन और जश्न",
      missionTitle: "हमारा सामुदायिक मिशन",
      missionText: "9Reason में, हम वापस देने में विश्वास करते हैं। हम सक्रिय रूप से उन कार्यक्रमों का समर्थन और आयोजन करते हैं जो हमारे समुदाय को एक साथ लाते हैं।",
      featuredTitle: "विशेष कार्यक्रम",
      upcomingTitle: "आगामी कार्यक्रम",
      pastTitle: "पिछले कार्यक्रम",
      viewDetails: "विवरण देखें",
      noEvents: "इस समय कोई कार्यक्रम निर्धारित नहीं है।",
      supportedBy: "गर्व से समर्थित",
      organizeTitle: "कोई कार्यक्रम आयोजित करना चाहते हैं?",
      organizeText: "हम हमेशा सामुदायिक पहलों का समर्थन करना चाहते हैं। यदि आपके पास कोई कार्यक्रम विचार है, तो संपर्क करें!",
      contactUs: "संपर्क करें"
    },
    pa: {
      title: "ਕਮਿਊਨਿਟੀ ਸਮਾਗਮ",
      subtitle: "ਸਾਡੀ ਸਥਾਨਕ ਕਮਿਊਨਿਟੀ ਦਾ ਸਮਰਥਨ ਅਤੇ ਜਸ਼ਨ",
      missionTitle: "ਸਾਡਾ ਕਮਿਊਨਿਟੀ ਮਿਸ਼ਨ",
      missionText: "9Reason ਵਿੱਚ, ਅਸੀਂ ਵਾਪਸ ਦੇਣ ਵਿੱਚ ਵਿਸ਼ਵਾਸ ਕਰਦੇ ਹਾਂ। ਅਸੀਂ ਸਰਗਰਮੀ ਨਾਲ ਉਨ੍ਹਾਂ ਸਮਾਗਮਾਂ ਦਾ ਸਮਰਥਨ ਅਤੇ ਆਯੋਜਨ ਕਰਦੇ ਹਾਂ ਜੋ ਸਾਡੀ ਕਮਿਊਨਿਟੀ ਨੂੰ ਇੱਕੱਠੇ ਲਿਆਉਂਦੇ ਹਨ।",
      featuredTitle: "ਵਿਸ਼ੇਸ਼ ਸਮਾਗਮ",
      upcomingTitle: "ਆਉਣ ਵਾਲੇ ਸਮਾਗਮ",
      pastTitle: "ਪਿਛਲੇ ਸਮਾਗਮ",
      viewDetails: "ਵੇਰਵੇ ਦੇਖੋ",
      noEvents: "ਇਸ ਸਮੇਂ ਕੋਈ ਸਮਾਗਮ ਨਿਰਧਾਰਤ ਨਹੀਂ ਹੈ।",
      supportedBy: "ਮਾਣ ਨਾਲ ਸਮਰਥਿਤ",
      organizeTitle: "ਕੋਈ ਸਮਾਗਮ ਆਯੋਜਿਤ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?",
      organizeText: "ਅਸੀਂ ਹਮੇਸ਼ਾ ਕਮਿਊਨਿਟੀ ਪਹਿਲਕਦਮੀਆਂ ਦਾ ਸਮਰਥਨ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹਾਂ। ਜੇ ਤੁਹਾਡੇ ਕੋਲ ਕੋਈ ਸਮਾਗਮ ਵਿਚਾਰ ਹੈ, ਤਾਂ ਸੰਪਰਕ ਕਰੋ!",
      contactUs: "ਸੰਪਰਕ ਕਰੋ"
    },
    fr: {
      title: "Événements Communautaires",
      subtitle: "Soutenir et célébrer notre communauté locale",
      missionTitle: "Notre Mission Communautaire",
      missionText: "Chez 9Reason, nous croyons au partage. Nous soutenons et organisons activement des événements qui rassemblent notre communauté.",
      featuredTitle: "Événements en Vedette",
      upcomingTitle: "Événements à Venir",
      pastTitle: "Événements Passés",
      viewDetails: "Voir les Détails",
      noEvents: "Aucun événement prévu pour le moment.",
      supportedBy: "Fièrement Soutenu Par",
      organizeTitle: "Voulez-vous Organiser un Événement?",
      organizeText: "Nous cherchons toujours à soutenir les initiatives communautaires. Si vous avez une idée d'événement, contactez-nous!",
      contactUs: "Contactez-nous"
    }
  },

  // ============================================
  // PROJECTS PAGE
  // ============================================
  projects: {
    en: {
      title: "Our Projects",
      subtitle: "Showcasing our work and the impact we've made",
      statsTitle: "By the Numbers",
      projectsDelivered: "Projects Delivered",
      happyClients: "Happy Clients",
      linesOfCode: "Lines of Code",
      yearsExperience: "Years Experience",
      featuredTitle: "Featured Projects",
      viewProject: "View Project",
      moreProjects: "More Projects Coming Soon",
      startProject: "Start Your Project",
      startProjectText: "Ready to bring your idea to life? Let's discuss your project."
    },
    hi: {
      title: "हमारे प्रोजेक्ट्स",
      subtitle: "हमारे काम और प्रभाव को प्रदर्शित करना",
      statsTitle: "संख्याओं में",
      projectsDelivered: "प्रोजेक्ट्स डिलीवर",
      happyClients: "खुश ग्राहक",
      linesOfCode: "कोड की लाइनें",
      yearsExperience: "वर्षों का अनुभव",
      featuredTitle: "विशेष प्रोजेक्ट्स",
      viewProject: "प्रोजेक्ट देखें",
      moreProjects: "और प्रोजेक्ट्स जल्द आ रहे हैं",
      startProject: "अपना प्रोजेक्ट शुरू करें",
      startProjectText: "अपने विचार को जीवन में लाने के लिए तैयार हैं? आइए आपके प्रोजेक्ट पर चर्चा करें।"
    },
    pa: {
      title: "ਸਾਡੇ ਪ੍ਰੋਜੈਕਟਸ",
      subtitle: "ਸਾਡੇ ਕੰਮ ਅਤੇ ਸਾਡੇ ਪ੍ਰਭਾਵ ਨੂੰ ਪ੍ਰਦਰਸ਼ਿਤ ਕਰਨਾ",
      statsTitle: "ਅੰਕੜਿਆਂ ਵਿੱਚ",
      projectsDelivered: "ਪ੍ਰੋਜੈਕਟਸ ਡਿਲੀਵਰ",
      happyClients: "ਖੁਸ਼ ਗਾਹਕ",
      linesOfCode: "ਕੋਡ ਦੀਆਂ ਲਾਈਨਾਂ",
      yearsExperience: "ਸਾਲਾਂ ਦਾ ਤਜਰਬਾ",
      featuredTitle: "ਵਿਸ਼ੇਸ਼ ਪ੍ਰੋਜੈਕਟਸ",
      viewProject: "ਪ੍ਰੋਜੈਕਟ ਦੇਖੋ",
      moreProjects: "ਹੋਰ ਪ੍ਰੋਜੈਕਟਸ ਜਲਦੀ ਆ ਰਹੇ ਹਨ",
      startProject: "ਆਪਣਾ ਪ੍ਰੋਜੈਕਟ ਸ਼ੁਰੂ ਕਰੋ",
      startProjectText: "ਆਪਣੇ ਵਿਚਾਰ ਨੂੰ ਜੀਵਨ ਵਿੱਚ ਲਿਆਉਣ ਲਈ ਤਿਆਰ ਹੋ? ਆਓ ਤੁਹਾਡੇ ਪ੍ਰੋਜੈਕਟ 'ਤੇ ਚਰਚਾ ਕਰੀਏ।"
    },
    fr: {
      title: "Nos Projets",
      subtitle: "Présentation de notre travail et de l'impact que nous avons eu",
      statsTitle: "En Chiffres",
      projectsDelivered: "Projets Livrés",
      happyClients: "Clients Satisfaits",
      linesOfCode: "Lignes de Code",
      yearsExperience: "Années d'Expérience",
      featuredTitle: "Projets en Vedette",
      viewProject: "Voir le Projet",
      moreProjects: "Plus de Projets à Venir",
      startProject: "Démarrer Votre Projet",
      startProjectText: "Prêt à donner vie à votre idée? Discutons de votre projet."
    }
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    en: {
      tagline: "Building Digital Excellence",
      quickLinks: "Quick Links",
      services: "Services",
      contact: "Contact",
      copyright: "© 2025 9Reason. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service"
    },
    hi: {
      tagline: "डिजिटल उत्कृष्टता का निर्माण",
      quickLinks: "त्वरित लिंक",
      services: "सेवाएं",
      contact: "संपर्क",
      copyright: "© 2025 9Reason. सर्वाधिकार सुरक्षित।",
      privacy: "गोपनीयता नीति",
      terms: "सेवा की शर्तें"
    },
    pa: {
      tagline: "ਡਿਜੀਟਲ ਉੱਤਮਤਾ ਦਾ ਨਿਰਮਾਣ",
      quickLinks: "ਤੇਜ਼ ਲਿੰਕ",
      services: "ਸੇਵਾਵਾਂ",
      contact: "ਸੰਪਰਕ",
      copyright: "© 2025 9Reason. ਸਾਰੇ ਹੱਕ ਰਾਖਵੇਂ ਹਨ।",
      privacy: "ਗੋਪਨੀਯਤਾ ਨੀਤੀ",
      terms: "ਸੇਵਾ ਦੀਆਂ ਸ਼ਰਤਾਂ"
    },
    fr: {
      tagline: "Construire l'Excellence Numérique",
      quickLinks: "Liens Rapides",
      services: "Services",
      contact: "Contact",
      copyright: "© 2025 9Reason. Tous droits réservés.",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation"
    }
  },

  // ============================================
  // COMMON
  // ============================================
  common: {
    en: {
      learnMore: "Learn More",
      readMore: "Read More",
      viewAll: "View All",
      back: "Back",
      next: "Next",
      previous: "Previous",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      close: "Close"
    },
    hi: {
      learnMore: "और जानें",
      readMore: "और पढ़ें",
      viewAll: "सभी देखें",
      back: "वापस",
      next: "अगला",
      previous: "पिछला",
      loading: "लोड हो रहा है...",
      error: "त्रुटि",
      success: "सफलता",
      close: "बंद करें"
    },
    pa: {
      learnMore: "ਹੋਰ ਜਾਣੋ",
      readMore: "ਹੋਰ ਪੜ੍ਹੋ",
      viewAll: "ਸਭ ਦੇਖੋ",
      back: "ਵਾਪਸ",
      next: "ਅਗਲਾ",
      previous: "ਪਿਛਲਾ",
      loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
      error: "ਗਲਤੀ",
      success: "ਸਫਲਤਾ",
      close: "ਬੰਦ ਕਰੋ"
    },
    fr: {
      learnMore: "En Savoir Plus",
      readMore: "Lire Plus",
      viewAll: "Voir Tout",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent",
      loading: "Chargement...",
      error: "Erreur",
      success: "Succès",
      close: "Fermer"
    }
  }
};

// Helper function to get translation
export const getTranslation = (section, language = 'en') => {
  return translations[section]?.[language] || translations[section]?.en || {};
};

export default translations;

